import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import AppointmentContext from '../../contexts/AppointmentContext';
import VisitInformation from '../../components/VisitInformation';
import * as authApi from '../../services/api/auth';
function SearchConfirmation(props){
  const {
    history,
    context,
    isAptRequest,
    classes: {
      container,
      containerForm,
      visitInfo,
      button,
      headerText,
      subtext,
    },
  } = props;

  const [provider, setProvider] = useState({});
  const [tenancy, setTenancy] = useState({});
  const [appointmentStart, setAppointmentStart] = useState('');
  // google analytics
  useEffect(()=>{
    window.pageview(window.location.pathname+window.location.search)
  },[])

  useEffect(() => {
    (async () => {
      window.scrollTo(0, 0);
      const { provider, start, tenancy } = context;

      if( !('isAptRequest' in props) ){
        if (!provider || !start || !tenancy) {
          history.push('/search');
          return;
        } 
        setTenancy(tenancy);
        setAppointmentStart(start);
        setProvider(provider);
      }else if('isAptRequest' in props){
       
        if(!provider){
          history.push('/search');
          return;
        }
        setProvider(provider);
      }
    })();
  }, []);

  function handleClick() {
    history.push('/patients');
  }

  

    return (
      <div className={container}>
        <Grid container spacing={8} className={containerForm}>
          <Grid item xs={12} sm={6} md={4} className={visitInfo}>
            <VisitInformation
              provider={provider}
              tenancy={tenancy}
              appointmentTime={appointmentStart}
              isAptRequest = {isAptRequest}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <h2 className={headerText}>You’re all set!</h2>

            {/* <p className={subtext}>
              {!isAptRequest?
                `Your appointment has been confirmed and we’ve sent you a
                confirmation email with all of the details.`
                :
                `Your appointment request has been submited and we’ve sent you a
                confirmation email with the details.`
              }
            </p> */}
             <p className={subtext}>
              {!isAptRequest?
                `Your appointment has been confirmed and we’ve sent you a
                confirmation email with all of the details.`
                : provider.active ?
                `We have received your appointment request with ${provider.name} , ${provider.degree} and we have sent the office your 
                contact information.  You may also reach out to  ${provider.name} , ${provider.degree}'s office directly at ${provider.phone}.     
                Thank you for using Qwell!` 
                : 
                `We have received your appointment request with ${provider.name} , ${provider.degree}. You may reach the office directly at ${provider.phone}. to schedule an appointment.   
                Thank you for using Qwell!` 
              }
            </p>

            {!isAptRequest && 
              <p className={subtext}>
                Need to reschedule or just can’t keep this appointment? You can
                cancel or reschedule anytime from your account.
              </p>
            }

            <Button
              onClick={handleClick}
              className={button}
            >
              Go to dashboard
              </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    marginBottom: '2em',
    height: 'calc(100% - 266px)',
    '@media only screen and (max-height: 736px)': {
      height: 'auto',
    },
  },
  containerForm: {
    width: '50%',
    padding: '1rem',
    paddingTop: '90px',
    display: 'flex',
    justifyContent: 'center',
    '@media only screen and (max-width: 1025px)': {
      width: '100%',
      paddingTop: '40px',
      flexDirection: 'column-reverse',
    },
  },
  button: {
    backgroundColor: '#0277bd',
    color: 'white',
    '&:visited': {
      color: 'white',
    },
  },
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1025px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '1.3em',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

SearchConfirmation.contextType = AppointmentContext;

export default withRouter(withStyles(styles)(SearchConfirmation));
